export const eur = (n) =>
  n === null || n === undefined ? "—" : "€" + Number(n).toLocaleString("en-US");

export const km = (n) =>
  n === null || n === undefined ? "—" : Number(n).toLocaleString("en-US") + " km";

export const scoreTier = (score) => {
  if (score >= 80) return { label: "Strong", color: "#059669", bg: "bg-emerald-50", text: "text-emerald-700", border: "border-emerald-200" };
  if (score >= 65) return { label: "Solid", color: "#2563EB", bg: "bg-blue-50", text: "text-blue-700", border: "border-blue-200" };
  if (score >= 50) return { label: "Average", color: "#D97706", bg: "bg-amber-50", text: "text-amber-700", border: "border-amber-200" };
  return { label: "Weak", color: "#64748B", bg: "bg-slate-100", text: "text-slate-600", border: "border-slate-200" };
};

export const confidenceStyle = (level) => {
  switch (level) {
    case "High": return { color: "#059669", text: "text-emerald-700", bg: "bg-emerald-50", border: "border-emerald-200" };
    case "Medium": return { color: "#D97706", text: "text-amber-700", bg: "bg-amber-50", border: "border-amber-200" };
    default: return { color: "#64748B", text: "text-slate-600", bg: "bg-slate-100", border: "border-slate-200" };
  }
};
